module.exports = __webpack_public_path__ + "images/cross_58e503cf9070e92f7a072ea81617025e.svg";